import ShorewoodSeal from '@/components/ui/ShorewoodSeal'

type LogoSpinnerSize = 'sm' | 'md' | 'lg' | 'xl'

interface LogoSpinnerProps {
  size?: LogoSpinnerSize
  /** Optional small caption beneath the seal. */
  label?: string
  className?: string
}

const sizeClasses: Record<LogoSpinnerSize, string> = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
}

const labelClasses: Record<LogoSpinnerSize, string> = {
  sm: 'text-[0.65rem] tracking-eyebrow',
  md: 'text-xs tracking-eyebrow',
  lg: 'text-xs tracking-wider-2',
  xl: 'text-sm tracking-wider-2',
}

const LogoSpinner = ({ size = 'md', label, className = '' }: LogoSpinnerProps) => (
  <div className={`inline-flex flex-col items-center gap-3 ${className}`} role="status">
    <div className={`logo-spinner-orbit ${sizeClasses[size]}`}>
      <ShorewoodSeal
        spinPaddle
        ariaLabel={label ? undefined : 'Loading'}
        className="w-full h-full"
      />
    </div>
    {label && (
      <span className={`font-sans font-semibold uppercase text-slate ${labelClasses[size]}`}>
        {label}
      </span>
    )}
  </div>
)

export default LogoSpinner
